import { updateItemInCollection } from "directus/src/operations";

export async function updateHoliday({ item, holidayId }) {
  try {
    const data = await updateItemInCollection("holidays", holidayId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
